import withStyles from '@material-ui/core/styles/withStyles'

export default withStyles(theme => {
  return {
    container: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: '#fff',
      borderRadius: 32,
    },
    info: {
      margin: 0,
      padding: 0,
      flex: 1,
    },
    siteIcon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 24,
      height: 24,
      margin: '0 19px 0 23px',
      color: '#fff',
      fontSize: 16,
      fontWeight: 600,
      borderRadius: '100%',
      backgroundColor: 'rgb(44, 50, 157)',
    },
  }
})
